import { Group, Paper, Stack, Text, Title } from "@mantine/core";
import { IconSquareRotatedFilled } from "@tabler/icons-react";

import lockerIcon from "@/assets/icons/locker.svg";
import { TextSerif } from "@/components/elements/TextSerif";

import type { PerformanceChart as IPerformanceChart } from "@/types/performance";
import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type PerformanceChartTooltipProps = {
  dataKeyFormatter?: (key: string) => string;
  disabledBenchmarks?: IPerformanceChart[];
  kpisDisabled?: boolean;
  label?: any;
  payload?: Record<string, any>[];
  valueFormatter?: (value: number) => string;
} & MantineStyleProps;

export const PerformanceChartTooltip: FC<PerformanceChartTooltipProps> = ({
  dataKeyFormatter,
  disabledBenchmarks = [],
  kpisDisabled = false,
  label,
  payload,
  valueFormatter,
  ...props
}) => {
  const mainItems = payload?.slice(0, -1) ?? [];
  const lastItem = payload && payload.length > 0 ? payload[payload.length - 1] : undefined;

  return (
    <Paper px="md" py="sm" withBorder shadow="md" {...props}>
      <Stack gap="xs">
        <Title order={5}>{label}</Title>
        <Stack gap="xs">
          {mainItems.map((item, index) => (
            <Group key={index} gap="xs">
              <IconSquareRotatedFilled color={item.color} size={10} />
              <TextSerif size="sm">
                {dataKeyFormatter ? dataKeyFormatter(item.dataKey) : item.dataKey}:
              </TextSerif>
              <Text size="sm">{valueFormatter ? valueFormatter(item.value) : item.value}</Text>
            </Group>
          ))}
          {kpisDisabled &&
            disabledBenchmarks.map((benchmark, index) => (
              <Group key={`disabled-${index}`} gap="xs">
                <IconSquareRotatedFilled color="var(--mantine-color-gray-5)" size={10} />
                <TextSerif size="sm" c="dimmed">
                  {dataKeyFormatter ? dataKeyFormatter(benchmark.name) : benchmark.name}:
                </TextSerif>
                <img src={lockerIcon} alt="locked" width={18} height={18} />
              </Group>
            ))}
          {lastItem && (
            <Group key="last-item" gap="xs">
              <IconSquareRotatedFilled color={lastItem.color} size={10} />
              <TextSerif size="sm">
                {dataKeyFormatter ? dataKeyFormatter(lastItem.dataKey) : lastItem.dataKey}:
              </TextSerif>
              <Text size="sm">
                {valueFormatter ? valueFormatter(lastItem.value) : lastItem.value}
              </Text>
            </Group>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};
